<template>

  <v-form class="text-h5" style="max-width: 800px">

    <v-overlay :value="loading">
      <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
    </v-overlay>
    <v-row class="text-h3 mb-8">
      {{ $t('deletePersonaInformationForm.personalDataDeleteForm') }}

    </v-row>

    <v-card class="pa-4" v-if="stage === 'login'">

      <v-col>
        <v-row>
          {{ $t('deletePersonaInformationForm.auth') }}
        </v-row>
        <v-row>
          <v-text-field :label="$t('deletePersonaInformationForm.username')" type="text" v-model="userinfo.username"
                        required/>
        </v-row>
        <v-row>
          <v-text-field :label="$t('deletePersonaInformationForm.password')" type="password" v-model="userinfo.password"
                        required/>
        </v-row>
      </v-col>

      <v-col>

        <v-btn @click="loginAskodChatUser()" :loading="loading"  class="mb-3">
          {{ $t('deletePersonaInformationForm.login') }}
        </v-btn>
      </v-col>
    </v-card>
    <v-card class="pa-3" v-if="stage === 'showPersonalInfo'">
      <v-col>
        <v-row>
          <v-col>
            <v-row>
              <v-img v-if="!imageLoadError" :src="imageUrl" style="border-radius: 150px;" cover max-width="300" width="300" height="300"
                     :placeholder="imagePlaceholder" @error="onImageError()" round></v-img>
              <v-row v-if="imageLoadError" class="justify-center align-center mt-4 ml-6" style="background-color: #B79F9F; max-width: 300px; height: 300px; border-radius: 50%; font-size: 150px; text-align: center">
                <v-card-text style="font-size: 150px;">{{imagePlaceholder}}</v-card-text>
              </v-row>

            </v-row>
          </v-col>

          <v-col>

            <v-row>{{ accessTokenModel.name }}</v-row>
            <v-row>{{ accessTokenModel.nameShort }}</v-row>

            <v-row v-if="accessTokenModel.organizationName">  {{
                $t('deletePersonaInformationForm.organizationName') + ": " + accessTokenModel.organizationName
              }}</v-row>
            <v-row v-if="accessTokenModel.departamentName">{{$t('deletePersonaInformationForm.departamentName') + ": " + accessTokenModel.departamentName }}</v-row>
          </v-col>
        </v-row>

        <v-row class="justify-center mt-8 pd-4 ">
          <v-btn @click="showDeleteUserDialog(true)" class="mb-3">
            {{ $t('deletePersonaInformationForm.deleteUser') }}
          </v-btn>
        </v-row>
      </v-col>
    </v-card>
    <v-card class="pa-8" v-if="stage === 'error'">
      <v-row class="text-h4 mb-2">
        {{ $t('deletePersonaInformationForm.occurError') }}
      </v-row>
      <v-row>
        <v-btn @click="loginAgain()">
          {{ $t('deletePersonaInformationForm.loginAgain') }}
        </v-btn>
      </v-row>

    </v-card>
    <v-dialog v-model="deleteUserDialog" width="500">
      <template>
        <v-card width="500" class="pa-1">
          <v-row>
            <v-card-title class="text-h4">{{ $t('deletePersonaInformationForm.deleteUserConfirmation') }}</v-card-title>
          </v-row>
          <v-row>
            <v-card-text class="text-h5">{{ $t('deletePersonaInformationForm.userInformationList') }}</v-card-text>
          </v-row>
          <v-row class="justify-center align-center mb-1">
            <v-col width="100" class="justify-center align-center ml-1">
              <v-btn color="blue" width="100%" @click="deleteAskodChatUser()">{{ $t('deletePersonaInformationForm.ok') }}</v-btn>
            </v-col>
            <v-col width="100" class="justify-center align-center mr-2">
              <v-btn width="100%" @click="showDeleteUserDialog(false)">{{ $t('deletePersonaInformationForm.no') }}</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="deleteResultDialog" width="300" >
      <template>
        <v-card class="pa-1" :color="deleteResult.isSuccess ? '#198754' : '#FF9494'">
          <v-row>
            <v-card-text class="text-h5 text-pre-wrap">{{ deleteResult.message }}</v-card-text>
          </v-row>
          <v-row class="justify-center mb-2">
            <v-btn width="150" color="blue" @click="loginAgain()">{{ $t('deletePersonaInformationForm.close') }}</v-btn>
          </v-row>
        </v-card>
      </template>
    </v-dialog>
  </v-form>
</template>

<script
>
import serviceDataAccess from '../../../services/service.data-access'

export default {
  name: 'DeletePersonaInformationForm',
  data: () => ({
    loading: false,
    stage: 'login',
    deleteUserDialog: false,
    deleteResultDialog: false,
    imageLoadError: false,
    deleteResult: {
      isSuccess: false,
      message: ''
    },
    userinfo: {
      username: '',
      password: ''
    },
    accessTokenModel: {
      accessToken: '',
      token_type: '',
      expiresIn: 0,
      refresh_token: '',
      userId: '',
      employeeId: '',
      moduleId: '',
      organizationId: '',
      languageId: '',
      name: '',
      login: '',
      MacAddress: '',
      ip: '',
      terminalName: '',
      nameShort: '',
      departamentName: '',
      organizationName: '',
      shortCaption: '',
      staff: '',
      hasDeputies: false,
      position: '',
      photoCreated: '0001-01-01T00:00:00'
    },
    PhotoCreatedConst: '0001-01-01T00:00:00',
    error: null
  }),
  methods: {

    onBeforeDelete(fileRecord) {
      console.log(fileRecord)
    },
    async loginAskodChatUser() {
      try {
        this.loading = true
        this.accessTokenModel = await serviceDataAccess.loginAskodChatUser(this.userinfo.username, this.userinfo.password)
        this.stage = 'showPersonalInfo'
      } catch (e) {
        console.log(e)
        this.stage = 'error'
        this.error = e.data
      } finally {
        this.loading = false
      }
    },
    showDeleteUserDialog(value) {
      this.deleteUserDialog = value
    },
    async deleteAskodChatUser() {
      try {
        this.loading = true
        this.showDeleteUserDialog(false)
        const result = await serviceDataAccess.deleteAskodChatUser(this.accessTokenModel.accessToken, this.accessTokenModel.userId)

        this.deleteResultDialog = true
        this.deleteResult = {
          isSuccess: result,
          message: result ? this.$t('deletePersonaInformationForm.deleteSuccess') : this.$t('deletePersonaInformationForm.deleteUnsuccessful')
        }
      } catch (e) {
        console.log(e)
        this.stage = 'error'
        this.error = e.data
      } finally {
        this.loading = false
        this.showDeleteUserDialog(false)
      }
    },
    loginAgain() {
      this.deleteResultDialog = false
      this.showDeleteUserDialog(false)
      this.error = null
      this.stage = 'login'
      this.deleteResult = {
        isSuccess: false,
        message: ''
      }
    },
    onImageError(el) {
      this.imageLoadError = true
    }
  },
  computed: {
    imageUrl: function () {
      return `${this.$store.getters.getApiBasePath}/askodchat/userImage?authToken=${this.accessTokenModel.accessToken}&userId=${this.accessTokenModel.userId}`
    },
    imagePlaceholder: function () {
      if (!this.accessTokenModel?.nameShort) { return '' }

      const nameShort = this.accessTokenModel.nameShort
      return nameShort.trim().charAt(0)
    }
  }

}
</script>

<style scoped lang="scss">

</style>
